import { Component } from "@angular/core";

@Component({
  selector: "toolbox-typography",
  templateUrl: "./typography.component.html",
  styleUrls: ["./typography.component.scss"],
})
export class TypographyComponent {}
